/**
 * ドキュメント title / description の既定文言。
 * index.html の静的メタと文言を揃える（クローラは JS 実行前の HTML を拾うため）。
 */
export const DEFAULT_DOCUMENT_TITLE = "CHILLNN 管理画面ログインページ";

/** ページ固有 title があるときの接尾辞（例: `トップ | CHILLNN 管理画面`） */
export const DOCUMENT_TITLE_SUFFIX = "CHILLNN 管理画面";

export const DEFAULT_DOCUMENT_DESCRIPTION = "直販予約システム CHILLNN 管理画面ログインページ";
